var commonErrorMessages = {
  VAL_00093: {
    description: 'MPLIB_INVALID_SERIAL_NUMBER'
  },
  VAL_00095: {
    description: 'MPLIB_INVALID_SERIAL_NUMBER'
  },
  VAL_00743: {
    description: 'MPLIB_NOT_ALLOWED_TO_REPLACE_WITH_THIS_DEVICE'
  },
  VAL_00558: {
    description: 'MPLIB_INVALID_SMS_TOKEN'
  },
  VAL_00559: {
    description: 'MPLIB_TOO_MANY_TOKEN'
  },
  VAL_00024: {
    description: 'MPLIB_ERROR_OCCURED_TRY_AGAIN'
  },
  VAL_00590: {
    description: 'MPLIB_ERROR_OCCURED_TRY_AGAIN'
  },
  VAL_00266: {
    description: 'MPLIB_ERROR_OCCURED_TRY_AGAIN'
  },
  VAL_00995: {
    description: 'MPLIB_ERROR_OCCURED_TRY_AGAIN'
  },
  VAL_01280: {
    description: 'MPLIB_DATE_ERROR_SET_LATER_DATE'
  },
  VAL_01752: {
    description: 'MPLIB_ERROR_DEVICE_ALREADY_CONNECTED'
  },
  VAL_01167: {
    description: 'MPLIB_ERROR_DEVICE_BLACKLISTED'
  },
  VAL_00876: {
    description: 'MPLIB_ERROR_REPLACE_NOT_ALLOWED_FOR_DEVICE'
  },
  AUT_00001: {
    description: 'MPLIB_ETC_LOGIN_FAILED_ALERT_MESSAGE'
  },
  AUT_00003: {
    description: 'MPLIB_ETC_LOGIN_FAILED_ALERT_MESSAGE'
  },
  AUT_00008: {
    description: 'MPLIB_KEYPAD_BLACKLISTED_MESSAGE'
  },
  AUT_00011: {
    description: 'MPLIB_ETC_SESSION_EXPIRED_MESSAGE'
  },
  AUT_00021: {
    description: 'MPLIB_TOO_MANY_REQUESTS_ERROR',
    title: 'MPLIB_TOO_MANY_REQUESTS_ERROR_TITLE'
  },
  AUT_00055: {
    title: 'MPLIB_PERMISSIONS_UPDATED_TITLE',
    description: 'MPLIB_PERMISSIONS_UPDATED_MESSAGE'
  },
  CUSTAPP_HAZARDOUS_SMART_PLUG: {
    description: 'MPLIB_SMART_BUTTONS_ERROR_CUSTAPP_HAZARDOUS_SMART_PLUG'
  },
  CUSTAPP_MAX_SMART_BUTTONS_REACHED: {
    description: 'MPLIB_MAX_SMART_BUTTONS_REACHED'
  },
  CUSTAPP_INVALID_DEVICE: {
    description: 'MPLIB_CUSTAPP_INVALID_DEVICE'
  },
  CUSTAPP_TOO_FREQUENT_IMAGE_CAPTURE_REQUEST: {
    description: 'MPLIB_SMART_BUTTONS_ERROR_TOO_FREQUENT_IMAGE_CAPTURE'
  },
  CUSTAPP_USER_VALIDITY: {
    title: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_TITLE',
    description: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_MESSAGE'
  },
  NETWORK_ERROR: {
    title: 'MPLIB_ETC_NO_NETWORK_ALERT_TITLE',
    description: 'MPLIB_ETC_NO_NETWORK_ALERT_MESSAGE'
  },
  VAL_00007: {
    description: 'MPLIB_TRIGGERS_SCHEDULED_EVENT_ERROR'
  },
  VAL_00008: {
    title: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_TITLE',
    description: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_MESSAGE'
  },
  'urn:verisure:gateway-user/code/invalid': {
    title: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_TITLE',
    description: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_MESSAGE'
  },
  VAL_00028: {
    title: 'MPLIB_INVALID_SERIAL_NUMBER_ALERT_TITLE',
    description: 'MPLIB_INVALID_SERIAL_NUMBER_ALERT_MESSAGE'
  },
  VAL_00815: {
    title: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_TITLE',
    description: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_MESSAGE'
  },
  VAL_00086: {
    description: 'MPLIB_CONTACT_ADD_TAG_ALREADY_IN_USE'
  },
  VAL_00087: {
    description: 'MPLIB_ETC_INVALID_INPUT_FOR_PROTECTED_AREA'
  },
  VAL_00143: {
    description: 'MPLIB_ETC_EDIT_ERROR_INVALID_EMAIL'
  },
  'urn:verisure:gateway-user/email/invalid': {
    description: 'MPLIB_ETC_EDIT_ERROR_INVALID_EMAIL'
  },
  VAL_00147: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_INVALID_CONTACT'
  },
  'urn:verisure:gateway-user/profile/invalid': {
    description: 'MPLIB_CONTACT_EDIT_ERROR_INVALID_CONTACT'
  },
  VAL_00214: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_INVALID_NAME'
  },
  VAL_00249: {
    description: 'MPLIB_SUPPORT_MESSAGE_ERROR_INVALID_MESSAGE'
  },
  VAL_00281: {
    description: 'MPLIB_ETC_NO_SMS_LEFT_ALERT_MESSAGE'
  },
  VAL_00315: {
    title: 'MPLIB_ETC_OLD_FIRMWARE_ALERT_TITLE',
    description: 'MPLIB_ETC_OLD_FIRMWARE_ALERT_MESSAGE'
  },
  VAL_00323: {
    description: 'MPLIB_SMARTPLUG_ENTRY_EXIT_CONTACT_MISSING'
  },
  VAL_00326: {
    description: 'MPLIB_ETC_NO_KEYPAD_ALERT_MESSAGE'
  },
  VAL_00342: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_00346: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_00432: {
    description: 'MPLIB_CONTROL_PLUG_INVALID_TIMER_VALUE'
  },
  VAL_00448: {
    description: 'MPLIB_REFERRAL_INVALID_NAME'
  },
  VAL_00449: {
    description: 'MPLIB_REFERRAL_INVALID_PHONE'
  },
  VAL_00535: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_NO_MOBILE_PHONE_FOR_SMS_NOTIFICATIONS'
  },
  VAL_00536: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_NO_EMAIL_FOR_EMAIL_NOTIFICATIONS'
  },
  VAL_00537: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_NO_MOBILE_PHONE_FOR_SMS_NOTIFICATIONS'
  },
  VAL_00538: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_NO_EMAIL_FOR_EMAIL_NOTIFICATIONS'
  },
  VAL_00539: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_NO_PHONE_NUMBER_FOR_OPERATOR_CONTACT'
  },
  VAL_00540: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_NO_PHONE_NUMBER_FOR_OPERATOR_CONTACT'
  },
  VAL_00546: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_INVALID_PHONE_NUMBER'
  },
  'urn:verisure:gateway-user/phonenumber/invalid': {
    description: 'MPLIB_CONTACT_EDIT_ERROR_INVALID_PHONE_NUMBER'
  },
  VAL_00555: {
    description: 'MPLIB_ETC_SET_CODE_SMS_TOKEN_TOO_OLD'
  },
  VAL_00556: {
    description: 'MPLIB_ETC_SET_CODE_TOO_MANY_SMS_TOKEN_ATTEMPTS'
  },
  VAL_00557: {
    description: 'MPLIB_ETC_SET_CODE_NO_SMS_TOKEN_GENERATED'
  },
  VAL_00586: {
    description: 'MPLIB_CONTACT_SET_CODE_ERROR_ALREADY_EXISTS'
  },
  VAL_00592: {
    description: 'MPLIB_CONTACT_LIST_ADD_TAG_ERROR_PIN_REQUIRED'
  },
  VAL_00593: {
    description: 'MPLIB_CONTACT_LIST_CANNOT_REMOVE_LAST_OPERATOR_CONTACT'
  },
  VAL_00603: {
    description: 'MPLIB_CONTACT_LIST_ADD_TAG_ERROR_PIN_REQUIRED'
  },
  'urn:verisure:gateway-user/doorlockpin/invalid': {
    description: 'MPLIB_CONTACT_LIST_ADD_TAG_ERROR_PIN_REQUIRED'
  },
  VAL_00628: {
    description: 'MPLIB_CONTROL_PLUG_HAZARD_SWITCH_ON_NOT_ALLOWED'
  },
  VAL_00640: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_00759: {
    title: 'MPLIB_OPERATOR_NOT_ALLOWED_WHEN_IMPERSONATING_TITLE',
    description: 'MPLIB_OPERATOR_NOT_ALLOWED_WHEN_IMPERSONATING_MESSAGE'
  },
  VAL_00784: {
    title: 'MPLIB_NO_ACCESS_TO_GIID_TITLE',
    description: 'MPLIB_NO_ACCESS_TO_GIID_MESSAGE'
  },
  VAL_00786: {
    description: 'MPLIB_PENDING_ONGOING_ARMSTATE_IN_PROGRESS'
  },
  VAL_00814: {
    description: 'MPLIB_PENDING_ONGOING_DOORLOCK_IN_PROGRESS'
  },
  VAL_00818: {
    description: 'MPLIB_REQUESTED_ARM_STATE_ALREADY_SET'
  },
  VAL_00819: {
    description: 'MPLIB_REQUESTED_DOORLOCK_STATE_ALREADY_SET'
  },
  VAL_00892: {
    description: 'MPLIB_PENDING_CHANGE_ALREADY_EXISTS'
  },
  VAL_00893: {
    description: 'MPLIB_ETC_GATEWAY_HAVE_NO_SMS_FUNCTIONALITY'
  },
  VAL_00913: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_00927: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_00949: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_00980: {
    description: 'MPLIB_IMAGE_CAMERA_TOO_MANY_CAPTURE_REQUESTS'
  },
  VAL_01009: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_01020: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_01169: {
    description: 'MPLIB_SMARTSCHEDULE_NO_ENTRY_WITH_SCHEDULENTRYID_FOUND'
  },
  VAL_01196: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_01199: {
    description: 'MPLIB_SMARTSCHEDULE_SIMILAR_ENTRY_ALREADY_EXISTS'
  },
  VAL_01259: {
    description: 'MPLIB_VOICEBOX_ERROR_ONGOING_TEST' // not exists
  },

  VAL_01307: {
    description: 'MPLIB_VOICEBOX_ERROR_TEST_FAILED'
  },
  VAL_01323: {
    description: 'MPLIB_ARM_FROM_OTHER_ARMSTATE_NOT_ALLOWED'
  },
  VAL_01352: {
    description: 'MPLIB_REMINDERS_DOORWINDOW_NOT_ENABLED'
  },
  VAL_01356: {
    title: 'MPLIB_CONTACT_EDIT_ERROR_PENDING_INVITE_TITLE',
    description: 'MPLIB_CONTACT_EDIT_ERROR_EMAIL_PHONE'
  },
  'urn:verisure:gateway-user/email/change-not-allowed': {
    title: 'MPLIB_CONTACT_EDIT_ERROR_PENDING_INVITE_TITLE',
    description: 'MPLIB_CONTACT_EDIT_ERROR_EMAIL_PHONE'
  },
  VAL_01357: {
    description: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_INVITE_FOR_EMAIL'
  },
  'urn:verisure:gateway-user/pending-invitation-exists': {
    description: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_INVITE_FOR_EMAIL'
  },
  VAL_01370: {
    description: 'MPLIB_ETC_INVALID_INVITATION'
  },
  VAL_01371: {
    title: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_CONTACT_WITH_EMAIL_TITLE',
    description: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_CONTACT_WITH_EMAIL_TEXT'
  },
  'urn:verisure:gateway-user/webaccount/exists': {
    title: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_CONTACT_WITH_EMAIL_TITLE',
    description: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_CONTACT_WITH_EMAIL_TEXT'
  },
  VAL_01372: {
    title: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_CONTACT_WITH_EMAIL_TITLE',
    description: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_CONTACT_WITH_EMAIL_TEXT'
  },
  'urn:verisure:gateway-user/contact/exists': {
    title: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_CONTACT_WITH_EMAIL_TITLE',
    description: 'MPLIB_CONTACT_EDIT_ERROR_EXISTING_CONTACT_WITH_EMAIL_TEXT'
  },
  VAL_01425: {
    title: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_TITLE',
    description: 'MPLIB_KEYPAD_WRONG_CODE_ALERT_MESSAGE'
  },
  VAL_01469: {
    description: 'MPLIB_ERROR_AT_LEAST_ONE_DOORLOCK_USER'
  },
  XBN_00029: {
    description: 'MPLIB_ETC_NO_SMS_LEFT_ALERT_MESSAGE'
  },
  CONTRACT_VIOLATION: {
    description: 'MPLIB_ETC_CONTRACT_VIOLATION'
  },
  CUSTAPP_MISSING_CAPABILITY: {
    title: 'MPLIB_EVENT_PM',
    description: 'MPLIB_ETC_CUSTAPP_MISSING_CAPABILITY'
  },
  VAL_00796: {
    description: 'MPLIB_INVALID_HEAT_PUMP_CONFIGURATION'
  },
  AUT_00050: {
    title: 'MPLIB_ETC_INVALID_ACCESS_TOKEN_TITLE',
    description: 'MPLIB_ETC_INVALID_ACCESS_TOKEN_MESSAGE'
  },
  VAL_01601: {
    description: 'MPLIB_MAX_NUMBER_OF_ENTRY_EXIT_LINKS_REACHED'
  },
  VAL_01110: {
    description: 'MPLIB_USER_SCHEDULE_NO_FULL_ACCESS'
  },
  'urn:verisure:gateway-user/useraccess/full-access-time-limitation': {
    description: 'MPLIB_USER_SCHEDULE_NO_FULL_ACCESS'
  },
  VAL_01107: {
    description: 'MPLIB_USER_SCHEDULE_DEFINE_WEEKDAY'
  },
  'urn:verisure:gateway-user/weekday/none-active': {
    description: 'MPLIB_USER_SCHEDULE_DEFINE_WEEKDAY'
  },
  VAL_01632: {
    description: 'MPLIB_USER_KEYFOB_ALREDY_LINKED' // not exists
  },

  CUSTAPP_WIZARD_EXISTS_FOR_DEVICE: {
    description: 'MPLIB_USER_KEYFOB_DEVICE_CONNECTED'
  },
  CUSTAPP_WIZARD_EXISTS_FOR_USER: {
    description: 'MPLIB_USER_KEYFOB_USER_CONNECTED'
  },
  CUSTAPP_ONLY_AVAILABLE_FOR_KEYFOB: {
    description: 'MPLIB_CUSTAPP_ONLY_AVAILABLE_FOR_KEYFOB'
  },
  CUSTAPP_DEVICE_MAY_NOT_BE_INSTALLED_BECAUSE_IT_HAS_BEEN_BLACKLISTED: {
    description: 'MPLIB_CUSTAPP_DEVICE_MAY_NOT_BE_INSTALLED_BECAUSE_IT_HAS_BEEN_BLACKLISTED'
  },
  CUSTAPP_REQUESTED_DEVICE_DOES_NOT_EXIST: {
    description: 'MPLIB_CUSTAPP_REQUESTED_DEVICE_DOES_NOT_EXIST'
  },
  CUSTAPP_DEVICE_ID_ALREADY_IN_USE: {
    description: 'MPLIB_CUSTAPP_DEVICE_ID_ALREADY_IN_USE'
  },
  AUT_00059: {
    description: 'MPLIB_KEYPAD_BLACKLISTED_MESSAGE'
  },
  CUSTAPP_ERROR_WHEN_LINKING_USER_TO_KEYFOB: {
    description: 'MPLIB_CUSTAPP_ERROR_WHEN_LINKING_USER_TO_KEYFOB'
  },
  WIFI_UNKNOWN: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_API_REQUEST: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_REQUESTED: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_OK: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_UNKNOWN_ERROR: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_TIMED_OUT: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_OUT_OF_RANGE: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_PIN_MISSING: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_DHCP_FAILED: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_CONNECT_FAILED: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_LOGIN_FAILED: {
    description: 'MPLIB_WIFI_ERROR_AUTHENTICATION_FAILED'
  },
  WIFI_AUTHENTICATION_FAILED: {
    description: 'MPLIB_WIFI_ERROR_AUTHENTICATION_FAILED'
  },
  WIFI_INVALID_KEY: {
    description: 'MPLIB_WIFI_ERROR_AUTHENTICATION_FAILED'
  },
  WIFI_BLOCKED: {
    description: 'MPLIB_WIFI_ERROR_CONNECTION_FAILED'
  },
  WIFI_BLOCKED_USINGETHERNET: {
    description: 'MPLIB_WIFI_ERROR_BLOCKED_USING_ETH'
  },
  VAL_01696: {
    description: 'MPLIB_CLIMATE_INSTALLATION_HAS_NO_CLIMATE_DEVICE'
  },
  VAL_01697: {
    description: 'MPLIB_CLIMATE_INSTALLATION_SHOULD_BE_ONLINE'
  },
  VAL_01673: {
    description: 'MPLIB_CALIBRATION_ERROR_IN_PROGRESS'
  },
  VAL_00159: {
    description: 'MPLIB_INVALID_DATE_RANGE'
  },
  AUT_00060: {
    description: 'MPLIB_USER_HAS_BEEN_BLACKLISTED'
  },
  VAL_00364: {
    description: 'MPLIB_CAMERA_TOO_LONG_TIMESPAN'
  },
  CCCP_DEVICE_LOW_BATT: {
    description: 'MPLIB_CCCP_DEVICE_LOW_BATT'
  },
  CCCP_ONGOING_ALARM_INCIDENT: {
    description: 'MPLIB_CCCP_ONGOING_ALARM_INCIDENT'
  },
  VAL_00765: {
    description: 'MPLIB_NON_EXISTING_TRANSACTION_ID'
  },
  AUT_00004: {
    description: 'MPLIB_ETC_LOGIN_FAILED_MESSAGE'
  },
  'urn:verisure:duress-manager/locked-userindex': {
    description: 'MPLIB_ETC_MAX_LOGIN_ATTEMPTS_TITLE'
  },
  'urn:verisure:duress-manager/invalid-state-transition': {
    description: 'MPLIB_ETC_ERROR_OCCURED_TRY_AGAIN' // illegal state transitions in the state machine for duress,
  },

  'urn:verisure:webaccount/owner-of-installation': {
    description: 'MPLIB_ETC_ERROR_OWNER_OF_INSTALLATION'
  },
  'urn:verisure:webaccount/not-yourself': {
    description: 'MPLIB_ETC_ERROR_NOT_YOURSELF'
  },
  'urn:verisure:webaccount/no-user-found': {
    description: 'MPLIB_ETC_ERROR_NO_USER_FOUND'
  },
  'urn:verisure:verify-installation/invalid-installation': {
    description: 'MPLIB_CONNECT_INSTALLATION_ERROR_INVALID_INSTALLATION',
    fatal: false
  },
  'urn:verisure:verify-installation/invalid-token': {
    description: 'MPLIB_CONNECT_INSTALLATION_ERROR_INVALID_TOKEN',
    fatal: false
  },
  'urn:verisure:verify-installation/incorrect-token': {
    description: 'MPLIB_CONNECT_INSTALLATION_ERROR_INCORRECT_TOKEN',
    fatal: false
  },
  'urn:verisure:verify-installation/invalid-monitoring-status': {
    description: 'MPLIB_CONNECT_INSTALLATION_FATAL_ERROR_DESCRIPTION',
    fatal: true
  },
  'urn:verisure:verify-installation/not-eligible-for-my-pages-status': {
    description: 'MPLIB_CONNECT_INSTALLATION_FATAL_ERROR_DESCRIPTION',
    fatal: true
  },
  'urn:verisure:verify-installation/contract-problem': {
    description: 'MPLIB_CONNECT_INSTALLATION_FATAL_ERROR_DESCRIPTION',
    fatal: true
  },
  'urn:verisure:verify-installation/already-has-verified-owner': {
    description: 'MPLIB_CONNECT_INSTALLATION_FATAL_ERROR_DESCRIPTION',
    fatal: true
  },
  'urn:verisure:verify-installation/invalid-web-account': {
    description: 'MPLIB_CONNECT_INSTALLATION_FATAL_ERROR_DESCRIPTION',
    fatal: true
  },
  'urn:verisure:verify-installation/invalid-action-plan': {
    description: 'MPLIB_CONNECT_INSTALLATION_FATAL_ERROR_DESCRIPTION',
    fatal: true
  },
  'urn:verisure:verify-installation/invalid-phone-number': {
    description: 'MPLIB_CONNECT_INSTALLATION_FATAL_ERROR_DESCRIPTION',
    fatal: true
  },
  'urn:verisure:verify-installation/no-pending-installation': {
    description: 'MPLIB_CONNECT_INSTALLATION_FATAL_ERROR_DESCRIPTION',
    fatal: true
  },
  'urn:verisure:verify-installation/impersonator-not-allowed': {
    description: 'MPLIB_CONNECT_INSTALLATION_ERROR_IMPERSONATOR_NOT_ALLOWED',
    fatal: true
  },
  'urn:verisure:webaccount/invalid-token': {
    description: 'MPLIB_WEBACCOUNT_EXPIRED_TOKEN',
    fatal: true
  },
  'urn:verisure:webaccount/incorrect-token': {
    description: 'MPLIB_WEBACCOUNT_INCORRECT_TOKEN',
    fatal: false
  },
  'urn:verisure:webaccount/web-account-already-exists': {
    description: 'MPLIB_WEBACCOUNT_ALREADY_EXISTS',
    fatal: false
  },
  VAL_01124: {
    description: 'MPLIB_NON_EXISITNG_BP_STATUS' // "Invalid or non existing battery process status"
  },

  VAL_01133: {
    description: 'MPLIB_NON_EXISITNG_BP_DEVICE_STATUS' // "Invalid or non existing battery process device status"
  },

  VAL_00165: {
    title: 'MPLIB_INVALID_SERIAL_NUMBER_TITLE',
    description: 'MPLIB_INVALID_SERIAL_NUMBER_MESSAGE'
  },
  POLL_TIMEOUT: {
    description: 'MPLIB_GENERIC_POLL_TIMEOUT'
  },
  RSSI_NO_VALID_INSTALL: {
    description: 'MPLIB_RSSI_INVALID_INSTALLATION_STATUS'
  },
  RSSI_NO_DEVICE: {
    description: 'MPLIB_RSSI_NO_DEVICE'
  },
  VAL_01271: {
    description: 'MPLIB_NO_PERMISSION_TO_REMOVE' // This device cannot be removed by an external user"
  },

  CU_NOT_FOUND: {
    description: 'MPLIB_FATAL_CU_NOT_FOUND'
  },
  CONTROL_PLUG_COULD_NOT_TOGGLE_STATE: {
    description: 'MPLIB_CONTROL_PLUG_COULD_NOT_TOGGLE_STATE'
  }
};
var getErrorCode = function getErrorCode(error) {
  if (!error) {
    return null;
  }
  var hasGqlError = error.graphQLErrors && error.graphQLErrors.length > 0 && error.graphQLErrors[0].data;
  return (hasGqlError === null || hasGqlError === void 0 ? void 0 : hasGqlError.errorCode) || (hasGqlError === null || hasGqlError === void 0 ? void 0 : hasGqlError.type) || error.code || error.errorCode || null;
};
var getCommonErrorMessage = function getCommonErrorMessage(errorCode) {
  var errorObj = commonErrorMessages === null || commonErrorMessages === void 0 ? void 0 : commonErrorMessages[errorCode];
  return errorObj ? {
    description: errorObj.description,
    title: errorObj.title ? errorObj.title : 'MPLIB_ERROR',
    fatal: errorObj.fatal ? errorObj.fatal : false
  } : {
    description: 'MPLIB_ERROR_OCCURED_TRY_AGAIN',
    title: 'MPLIB_ERROR',
    fatal: false
  };
};

export { commonErrorMessages, getCommonErrorMessage, getErrorCode };
